import React from "react";
import "./App.css";
import DownloadLanding from "./pages/DownloadLanding";

function App() {
  return <DownloadLanding />;
}

export default App;

